<template>
    <div>
      <div class="caja-filtro container">
        <!-- <div class="campo-filtro">

        <input type="text" class="form-control"/> 
      </div> -->
        
        <div class="form-control " style="margin-top: 1em;">
        <select class="form-control ">
            <option selected>Convocatoria CJE/01/2023</option>
            <!-- <option>Convocatoria Uno</option>
            <option>Convocatoria Uno</option> -->
        </select> 
    </div>
        <!-- <div class="caja-fecha">
        <Datepicker v-model="FechaInicial" :value="FechaInicial" :language="es" input-class='form-control input-fecha' format="dd-MM-yyyy"></Datepicker> 
       
        </div> -->
        <!-- <div class="campo-filtro">
             <Datepicker v-model="FechaFinal" :value="FechaFinal" :language="es" input-class='form-control input-fecha' format="dd-MM-yyyy" ></Datepicker> 
        </div> -->
        <div class="campo-filtro">
             <button class="btn btn-info" @click="obtenerAspirantes">Filtrar</button>
             <!-- <button class="btn btn-success">Limpiar Filtro</button> -->
        </div>

      </div>
    
      <div class="caja-tabla-asistentes">
        <table
                            class="table table-striped table-light table-hover"
                            id="tabla-asistentes"              
                            data-toggle="table"
                            data-pagination="true"
                            data-undefined-text="Sin información"
                            data-maintain-selected="true"  
                            data-page-size = "10"
                            data-page-list="[5,10,20,all]"
                            data-click-to-select="false"
                            data-search="true">
                            <thead class="thead-green">
                                <tr>
                                    <!-- <th id="tabla-asistentes" data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th> -->
                                   
                                    <!-- <th id="columna-texto-descriptivo-VEDC-pw" data-events="operateEvents" data-halign="center" data-width="35" data-align="center" data-field="NombreAspirante" data-sortable="true">
                                        Nombre del Aspirante
                                    </th>
                                    <th data-events="operateEvents" data-width="15"  data-halign="center" data-align="center" data-field="Email">  :data-formatter="this.formateadorHTMLAccionesContenidos()" -->
                                        <!-- Email
                                    </th>
                                    <th data-halign="center" data-width="15" data-align="center" data-field="FechaNacimiento" data-sortable="true">
                                        Fecha Nacimiento
                                    </th>
                                    <th data-events="operateEvents" id="switch-contenido-activo" data-width="10" data-field="Domicilio" data-halign="center" data-align="center">
                                        Domicilio
                                    </th>
                                    <th data-events="operateEvents" data-width="15" data-halign="center" data-align="center" data-field="Telefono" >
                                        Teléfono
                                    </th>-->
                                    <!-- <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAccionDescargarZip()" data-halign="center" data-align="center">
                                        Acciones
                                    </th>  -->
                                 </tr>
                            </thead>
                        </table>
      </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import axios from "axios"
import api from '@/../static/js/api'

export default{
    components:{
        Datepicker
    },

    data(){
        return{
            FechaInicial:null,
            FechaFinal:null,
            es:es,
            Encabezados:null
        }
    },
    methods:{
        obtenerDocumentoZIP:async function(datos){
            console.log(datos)
            

 //let dialog = bootbox.dialog({
   //                  message: '<div style="text-align:center"><i class="fas fa-spinner fa-spin" style="color:#09BCEC;font-size:3em"></i><br> <p style="font-size:2em" class="text-center mb-0"> Por favor espere mientras se genera el comprimido.</p></div>',
     //                closeButton: false
       //              });
let nombreArchivo =`${datos.NombreAspirante}_Folio_${datos.IdAspirante}.bz2`;
//const SERVIDOR = api.conexion;             
//const METODO_API_AGREGAR = "/SICPO/ConvocatoriasPagina/ObtenerZip?Folio="+datos.IdAspirante;
//const END_POINT = SERVIDOR+METODO_API_AGREGAR;
let peticion = [];
//let peticion = {
//    IdAspirante:datos.IdAspirante
//};
 //return axios.post(END_POINT, {responseType: 'arraybuffer'}).then(async response => {
  //  console.log("respuesta:::",response)
   // let contentDisposition = response.headers['Content-Disposition'];
   // let filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
   // const filename = filenameMatch[1].trim().replace(/^"(.*)"$/, '$1');
 //   console.log('filename:', filenameMatch);


    //if(response.data.SiHayError){
   //      dialog.modal('hide');
   //      bootbox.dialog({                  
    //                 message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información, por favor intente más tarde.</p></div>',
      //               buttons: {
       //              cancel: {
         //            label: "Cerrar",
        //             className: 'btn-danger',
       //          }
      //       }
     //    });
                   
    //}else{
        // dialog.modal('hide');
        // const blob = new Blob([response.data], {type: 'application/x-bzip'});
        // if(window.navigator.msSaveOrOpenBlob) {
        //     console.log("entra")
        //   window.navigator.msSaveBlob(blob, nombreArchivo);
        // }
        // else{
            // console.log("entra222")
            // console.log("entra222::",blob)
            // console.log("entra222::",window.URL.createObjectURL(blob))
        //   const elem = window.document.createElement('a');
        //   elem.href = window.URL.createObjectURL(blob);
        //   elem.download = nombreArchivo;       
        //   document.body.appendChild(elem);
        //   elem.click();        
        //   document.body.removeChild(elem);
        // }
        // this.limpiarFormulario();
        // dialog.modal('hide');
        // bootbox.dialog({                  
        //             message: '<div style="text-align:center"><i class="fas fa-check-circle" style="color: #07cf9d;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Felicidades!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Su registro ha sido exitoso, el folio de su solicitud es '+response.data.folioAspirante+' además se le ha enviado un correo de confirmación a la dirección especificada.</p></div>',
        //             buttons: {
        //             cancel: {
        //             label: "Entendido",
        //             className: 'btn-info',
        //         }
        //     }
        // });
        
   // }
 //}).catch(e => {
  //  dialog.modal('hide');
   // console.log("A sucedido un error en el sistema::",e.message);
// });

},
obtenerAspirantes:async function(){

// let dialog = bootbox.dialog({
//                     message: '<div style="text-align:center"><i class="fas fa-spinner fa-spin" style="color:#09BCEC;font-size:3em"></i><br> <p style="font-size:2em" class="text-center mb-0"> Por favor espere mientras procesamos la información.</p></div>',
//                     closeButton: false
//                     });
const SERVIDOR = api.conexion;             
const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.convocatoriasWeb.ObtenerAsistentesPorConvocatoria;;
const END_POINT = SERVIDOR+METODO_API_AGREGAR;
let peticion = {
    nombreAspirante:null,
    fechaInicial:null,
    fechaFinal:null,
    idConvocatoria:2
};
 return axios.post(END_POINT, peticion).then(async response => {
    console.log("respuesta:::",response)
// let datos = response.data.aspirantes
   

// var objeto={}
// datos.forEach((a,i)=>{
//     let llave = a.Nombre
//     objeto[llave] = a.tipo;
    
// })
// console.log("aaaaaa:::::",objeto)


// let contentDisposition = response.headers['Content-Disposition'];
   // let filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
   // const filename = filenameMatch[1].trim().replace(/^"(.*)"$/, '$1');
 //   console.log('filename:', filenameMatch);


    if(response.data.SiHayError){
         dialog.modal('hide');
         bootbox.dialog({                  
                     message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información, por favor intente más tarde.</p></div>',
                     buttons: {
                     cancel: {
                     label: "Cerrar",
                     className: 'btn-danger',
                 }
             }
     });
                   
    }else{
       
   var aspirantes =[]
       response.data.aspirantes.forEach(element => {
            var objeto = {};
          element.forEach((e) => {
            let llave = e.Nombre
            objeto[llave] = e.valor;
          })
          aspirantes.push(objeto)
        });
        this.Encabezados = response.data.formulario;
        console.log("formulario::::",response.data.formulario)
        console.log("aspirantes::::",aspirantes)
var columnas = []
columnas.push({title:"Folio",field:"Folio",align:"left"})
        this.Encabezados.filter(f => f.tipo!=6).forEach(element => {
            let columna = {}
            columna.title=element.Nombre
            columna.field = element.Nombre
            columna.align = "left"
            columnas.push(columna)
        });
let accion ={}
accion.title = "Acciones"
accion.formatter = this.formateadorHTMLAccionDescargarZip()
accion.align ="center"
columnas.push(accion)      
 
         this.$nextTick(() => {
         $("#tabla-asistentes").bootstrapTable({  data: aspirantes,columns:columnas });      
         $("#tabla-asistentes").bootstrapTable('load', aspirantes);  
         });
          

        
    }
 }).catch(e => {
  //  dialog.modal('hide');
    console.log("A sucedido un error en el sistema::",e.message);
 });

},




formateadorHTMLAccionDescargarZip: () => {
            return [
            '<div>',
            '<button id="descargar-documentos" type="button" class="btn btn-sm btn-xs btn btn-success texto-ajustable align-middle align-center"><i class="far fa-file-archive"></i>&nbsp;&nbsp;Descargar Documentos</button>',
            /* '<button id="eliminar-contenido-pw-SICPO" type="button" class="btn btn-sm btn-xs btn-danger texto-ajustable align-middle align-center p-1"><i class="fas fa-trash" ></i></button>', */
            '</div>'
            ].join("");
        },

    },
    mounted() {

        this.obtenerAspirantes();
        window.operateEvents = {
            "click #descargar-documentos": (e,val,row,index) => {          
                this.obtenerDocumentoZIP(row);
            },
        }
    },

    computed: {
    // a computed getter
    reversedMessage: function () {
      // `this` points to the vm instance
      return this.Encabezados
    }
  }




}
</script>

<style scoped>
.thead-green{
    background-color: var(--verde-pj-100) !important;
    color: white;
}
.caja-filtro{
     /* background-color: rgb(218, 208, 208);  */
     border: solid cadetblue;
    text-align: center;
    display: flex;
    width: 50%;
}
.caja-tabla-asistentes{
    /* background-color: blue; */
    margin: 5em;
}
.campo-filtro{
    width: 20%;
    margin-right: 1em;
    margin-block: 1em;
}
.campo-filtro button{
    background-color: var(--verde-pj-100);
}
.campo-filtro button:hover{
    background-color: var(--verde-pj);
}
.fecha-prefix{
   width: 100%;

}
.caja-fecha{
    width: 20%;
    background-color: green;
    margin-right: 1em;
    margin-block: 1em;
    display: flex;
}


</style>


// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/ConvocatoriasWeb/AdministracionAsistentes.vue